import { Injectable } from '@angular/core';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class MutationCreateLocationGroupGQL extends Mutation<any> {
  document = gql`
    mutation createLocationGroup($input: LocationGroupInput!) {
      createLocationGroup(input: $input) {
        id
      }
    }
  `;
}

@Injectable({
  providedIn: 'root'
})
export class MutationUpdateLocationGroupGQL extends Mutation<any> {
  document = gql`
    mutation updateLocationGroup($id: ID!, $input: LocationGroupInput!) {
      updateLocationGroup(id: $id, input: $input) {
        name
        archived
        description
      }
    }
  `;
}
